import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';

import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {
    getUsers,
    getUser,
    editUser,
    addUser,
} from '@pluto/rest';
import {SortingOptionsValues} from '@pluto/table';
import {
    UserListFilterParams,
    UserPromise,
} from '../UsersTypes';

export const USERS_SET = 'USERS_SET';
export const USER_SET = 'USER_SET';
export const USER_RESET = 'USER_RESET';

export const setUsersAction = createAction<UserPromise>(USERS_SET, async (params?: UserListFilterParams) => {
    const queryParams = params ?? {
        sortBy: 'email',
        sortOrder: SortingOptionsValues.asc,
        limit: 100,
        offset: 0,
    };
    
    return await getUsers(queryParams);
});

export const addUserAction = curry(async (params, dispatch) => {
    const [error] = await tryToCatch(addUser, params);
    
    if (!error)
        return dispatch(setNotification({
            type: 'success',
            text: 'User successfully added',
        }));
    
    const {data: errorData} = error.response;
    
    dispatch(setNotification({
        type: 'error',
        text: errorData.message,
    }));
});

export const editUserAction = curry(async (params, dispatch) => {
    const [error] = await tryToCatch(editUser, params);
    
    if (!error)
        return dispatch(setNotification({
            type: 'success',
            text: 'User successfully updated',
        }));
    
    const {data: errorData} = error.response;
    
    dispatch(setNotification({
        type: 'error',
        text: errorData.message,
    }));
});

export const setUserAction = createAction(USER_SET, async (id: number) => {
    return await getUser(id);
});

export const resetUserAction = createAction(USER_RESET);
